import { ChevronLeft } from "lucide-react";
import { Dispatch, ReactNode, SetStateAction } from "react";

export default function EnrollWrapper({
  isOpen,
  perPageDropDownComponent,
  children,
  paginationComponent,
  setIsOpen,
}: {
  isOpen: boolean;
  perPage: number;
  perPageDropDownComponent: JSX.Element;
  children: ReactNode;
  paginationComponent: ReactNode;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}) {
  return (
    <div
      className={`relative ${
        isOpen
          ? ""
          : "max-md:w-full max-md:absolute top-0 bottom-0 max-md:left-0 max-md:z-[4] h-full bg-white"
      }`}
    > 
      <div
        className={`z-[9] relative left-sidebar max-md:w-full max-md:max-w-full md:w-[25rem]   border-r border-[#EAECF0] bg-white transition-all ease-in-out delay-100 h-full ${
          isOpen
            ? "max-md:invisible max-md:!w-0 max-md:-translate-x-full"
            : "invisible !w-0 -translate-x-full max-md:visible max-md:!w-full max-md:translate-x-0"
        } `}
      >
        <div
          className={`transition-all ease-in-out delay-0 h-full ${
            isOpen ? "max-md:invisible" : "invisible max-md:visible"
          }`}
        >
          <div className="flex min-h-screen h-full justify-between flex-col">
            <div className="flex flex-col justify-between">
              <div className="content bg-white">
                <div className="flex justify-between items-center p-4 bg-[#F2F4F7]">
                  <div className=" text-xl font-semibold ">
                    Student Enrollment
                  </div>
                  <div className="perpage-wrap mr-2">
                    {perPageDropDownComponent}
                  </div>
                </div>
                <div className="flex flex-col h-full">{children}</div>
              </div>
            </div>
            <div className="pagination flex justify-center items-center w-full px-4 py-2 bg-slate-50 [&_li>a]:h-8 [&_li>a]:w-8">
              {paginationComponent}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`z-[9] rounded-full bg-white inline-flex justify-center items-center w-10 h-10 shadow-sm absolute  top-2  ${
          isOpen ? "-right-5 max-md:-right-11" : "-right-11 max-md:right-1"
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <ChevronLeft
          className={`${
            isOpen
              ? "max-md:rotate-180"
              : " transition-all ease-in-out delay-300 rotate-180 max-md:rotate-0"
          }`}
        />
      </div>
    </div>
  );
}
